import React, {Component} from "react";


class InputCheck extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        var realValue = this.props.blockItem.values[0];
        if (realValue=='false') { realValue = false };
        if (realValue=='true') { realValue = true };
        this.state = {
            [name]: realValue
        };

        const e = {target: {name: name, value: realValue}};
        this.props.onChange(e);

        this.change = this.change.bind(this);
    }

    change(e) {
        this.setState({
            [e.target.name]: !this.state[e.target.name]
        });
        this.props.onChange(e);
    }


    render() {
        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        return (
            <div className="coreBlockItem-value" style={JSON.parse(this.props.blockItem.inputCss)}>
                <input type="checkbox"
                       className="coreBlockItem-input coreBlockItem-typeCheckbox"
                       name={name}
                       defaultChecked={this.state[name]}
                       value={this.state[name]}
                       onClick={this.change}
                />
            </div>
        );
    }
}

export default InputCheck;